import {z} from 'zod'

import {CreateOrUpdateBlockVideoDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {videoProviderSchema} from '../../utils/getCreateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'

import type {BlockVideoInput, CreateOrUpdateBlockVideoMutation} from '@sdox/api'

type UpdateVideoValidatorSchema = z.infer<typeof updateVideoValidatorSchema>

const updateVideoValidatorSchema = z.object({
  data: z.object({
    videoUrl: videoProviderSchema,
    thumbnail: z.object({
      fileHash: z.string().min(1),
    }),
  }),
  meta: updateMetaSchema,
})

export const videoConfig = createFormConfig<
  UpdateVideoValidatorSchema,
  CreateOrUpdateBlockVideoMutation,
  BlockVideoInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockVideoDocument,
  },
  fieldMapper: (fieldValues) => ({
    videoUrl: fieldValues.data.videoUrl,
    thumbnailHash: fieldValues.data.thumbnail?.fileHash ?? null,
  }),
  validatorSchema: updateVideoValidatorSchema,
  inputFields: [
    {
      label: 'Video URL (YouTube oder Vimeo)',
      fieldName: 'data.videoUrl',
      inputType: 'link',
      defaultValue: '',
      required: true,
    },
    {
      label: 'Image',
      fieldName: 'data.thumbnail',
      inputType: 'image',
      defaultValue: '',
      required: true,
    },
  ],
})
